"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performSearch = void 0;
const getEngineUrl_1 = require("./utils/getEngineUrl");
const isWebUrl_1 = require("./utils/isWebUrl");
const getTargetUrlByOptions = (query, engine, options) => {
    const engineUrl = (0, getEngineUrl_1.getEngineUrl)(engine);
    let targetUrl = engineUrl + query;
    if (options?.directLink && (0, isWebUrl_1.isWebUrl)(query))
        targetUrl = query;
    if (options?.forwardingLookup?.[query])
        targetUrl = options?.forwardingLookup?.[query];
    return targetUrl;
};
const performSearch = (query, engine, options) => {
    const targetUrl = getTargetUrlByOptions(query, engine, options);
    const target = options?.newTab ? "_blank" : "_self";
    window.open(targetUrl, target);
};
exports.performSearch = performSearch;
